<template>
  <div class="width100 margin-auto">
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <!-- 检索 -->
        <div class="backwhite">
          <div class="pad-bot10 dimensional">合同详情</div>
          <div class="pad-top20 flex-betweenwrap f14">
            <div label="合同名称：" class="width100 flex">
              <p class="width20 margin-bot10">合同名称：</p>
              <span class="dimencont"> {{ form.title }}</span>
            </div>
            <div label="签署时间：" class="width100 pad-top10 flex">
              <p class="width20 margin-bot10">签署时间：</p>
              <span class="dimencont"> {{ form.write_date }}</span>
            </div>
            <div label="电子合同：" class="width100 pad-top10 flex">
              <p class="width20 margin-bot10">电子合同：</p>
              <span class="dimencont"> {{ filename }}</span>
            </div>
            <div label="合同金额：" class="width100 pad-top10 flex">
              <p class="width20">合同金额：</p>
              <span class="dimencont"> {{ form.amount }}万</span>
            </div>
            <div label="合同名称：" class="width100 pad-top10 flex">
              <p class="width20 margin-bot10">合作方名称：</p>
              <span class="dimencont"> {{ form.parter }}</span>
            </div>
            <div label="备注：" class="width100 pad-top10 flex">
              <p class="width20 margin-bot10">备注：</p>
              <span class="dimencont"> {{ form.remark }}</span>
            </div>
          </div>
          <div class="textalign-right margin-top20">
            <el-button @click="dialognull()">关闭</el-button>
            <el-button
              class="margin-top10"
              type="primary"
              @click="sinkcontract()"
              >预 览
            </el-button>
          </div>
        </div>
      </template>
    </el-skeleton>
  </div>
</template>
<script>
import { entcontractdetail } from "@/api/Center/Center.api";
import { Base64 } from "js-base64";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      Apisrc: "",
      form: {
        title: "",
        parter: "",
        amount: "",
        write_date: "",
        remark: "",
      },
      file: "",
      filename: "",
    };
  },
  methods: {
    sinkcontract() {
      var url = window.g.Apisrc + this.filename;
      window.open(
        "http://i.icdicn.com:8012/onlinePreview?url=" +
          encodeURIComponent(Base64.encode(url))
      );
    },
    dialognull() {
      BUS.$emit("enterpriseaddfication", "yess");
    },
  },
  created() {
    this.Apisrc = window.g.ApiUrl + "/oss_form";

    entcontractdetail({
      id: window.sessionStorage.getItem("Enterprisemodification"),
    }).then((res) => {
      this.form.title = res.data.data.title;
      this.form.parter = res.data.data.parter;
      this.form.amount = res.data.data.amount;
      this.form.cate_id = res.data.data.cate_id;
      this.form.write_date = res.data.data.write_date;
      this.filename = res.data.data.file;
      this.form.remark = res.data.data.remark;
    });
  },
  mounted() {
    BUS.$on("Enterprisemodification", (data) => {
      entcontractdetail({
        id: data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.form.title = res.data.data.title;
          this.form.parter = res.data.data.parter;
          this.form.amount = res.data.data.amount;
          this.form.cate_id = res.data.data.cate_id;
          this.form.write_date = res.data.data.write_date;
          this.file = res.data.data.file;
          this.filename = res.data.data.file;
          this.form.remark = res.data.data.remark;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    });
  },
};
</script>
<style scoped>
</style>